var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"principal"}},[(_vm.value == '#NA#')?_c('span',{staticClass:"na-grid-cell"},[_vm._v("\n    N/A\n  ")]):(_vm.value == '#NREF#')?_c('span',{staticClass:"nref-grid-cell"},[_vm._v("⠀")]):_c('span',[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0afbb39e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/operational/pci/components/DateCellRenderer.vue
// module id = null
// module chunks = 